import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import {Props} from './model';

const View: React.FC<Props> = ({children, open, onClose}) => {
  return (
    <Drawer open={open} anchor='right' onClose={onClose}>
      {children}
    </Drawer>
  );
};

export default View;
